import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TOvertime } from 'shared/types/overtime.types';

const initialState: TOvertime[] = [];

export const overtimeCrudSlice = createSlice({
  name: 'overtimes/crud',
  initialState,
  reducers: {
    addOvertime: (state, { payload }: PayloadAction<TOvertime>) => {
      state.push(payload);
    },
    deleteOvertime: (state, { payload }: PayloadAction<TOvertime>) => {
      return state.filter(elem => elem.id !== payload.id);
    },
    updateOvertime: (state, { payload }: PayloadAction<TOvertime>) => {
      return state.map(elem => {
        if (elem.id === payload.id) {
          return payload;
        }
        return elem;
      });
    },
  },
});

export const overtimesCrudActions = overtimeCrudSlice.actions;
export const reducer = overtimeCrudSlice.reducer;
